import { AxiosPromise, AxiosStatic } from "axios";
import {
  MembershipCheckoutSession,
  MembershipCheckoutSessionInput,
} from "../types/Payment";
import { Payment } from "../types/Commitment";

export const membershipCheckoutSession =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    payload: MembershipCheckoutSessionInput
  ): AxiosPromise<MembershipCheckoutSession> =>
    await appAxios.post(
      `${serverURL}/payments/membershipCheckoutSession`,
      payload,
      {
        withCredentials: true,
      }
    );

export const acknowledgePayment =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (paymentId: string): AxiosPromise<Payment> =>
    await appAxios.post(
      `${serverURL}/payments-v2/${paymentId}/acknowledge`,
      {},
      {
        withCredentials: true,
      }
    );

export const cancelPayment =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (paymentId: string): AxiosPromise<Payment> =>
    await appAxios.post(
      `${serverURL}/payments-v2/${paymentId}/cancel`,
      {},
      {
        withCredentials: true,
      }
    );
